import { getDistance } from 'geolib';

import { ShippingGroup } from './types';

export function sortShippingGroups(
  groups: Array<ShippingGroup>,
  position: { latitude: number; longitude: number },
  ipPosition: { data: { loc: string } },
): Array<ShippingGroup> {
  const positionValid = position.latitude && position.longitude;
  const ipPositionValid = ipPosition.data && ipPosition.data.loc;

  const lastFoodGroupOriginalId = localStorage.getItem('last-food-group');
  const lastFoodGroup = lastFoodGroupOriginalId
    ? groups.find(
        g =>
          g.originalShippingGroupId === lastFoodGroupOriginalId || g.id === lastFoodGroupOriginalId,
      )
    : null;
  const lastRegularGroupOriginalId = localStorage.getItem('last-regular-group');
  const lastRegularGroup = lastRegularGroupOriginalId
    ? groups.find(
        g =>
          g.originalShippingGroupId === lastRegularGroupOriginalId ||
          g.id === lastRegularGroupOriginalId,
      )
    : null;

  return groups
    .map(g => {
      if (g.latitude && g.longitude) {
        if (positionValid) {
          return {
            ...g,
            distance: getDistance(position, groupToPoint(g)),
          };
        } else if (ipPositionValid) {
          return {
            ...g,
            distance: getDistance(ipPositionToPoint(ipPosition.data), groupToPoint(g)),
          };
        }
      }
      return {
        ...g,
        distance: NaN,
      };
    })
    .sort((g1, g2) => {
      if (g1.id === lastFoodGroup?.id || g1.id === lastRegularGroup?.id) {
        return -1;
      } else if (g2.id === lastFoodGroup?.id || g2.id === lastRegularGroup?.id) {
        return 1;
      } else if (positionValid || ipPositionValid) {
        return g1.distance > g2.distance ? 1 : g1.distance < g2.distance ? -1 : 0;
      } else {
        return g1.deadline < g2.deadline ? 1 : g1.deadline > g2.deadline ? -1 : 0;
      }
    });
}

function groupToPoint(group: ShippingGroup) {
  return {
    latitude: group.latitude || 0,
    longitude: group.longitude || 0,
  };
}

function ipPositionToPoint(data) {
  const loc = data.loc.split(',');
  if (loc.length < 2) {
    return {
      latitude: 0,
      longitude: 0,
    };
  }
  return {
    latitude: loc[0],
    longitude: loc[1],
  };
}

export const locationApi = 'https://ipinfo.io/json';
